import ElectrodeElectrifyReactComponent from "./components/electrode-electrify-react-component";
export default ElectrodeElectrifyReactComponent;



// WEBPACK FOOTER //
// ./src/index.js